<style lang="less" scoped>
.expansion-contain {
     /deep/.v-expansion-panel {
       &:before {
           box-shadow: 
           1px 0px 0px 0px rgba(0, 0, 0, 0.2),
            0px 1px 0px 0px rgba(0, 0, 0, 0.2),
             0px 0px 1px 0px rgba(0, 0, 0, 0.2),
              0px 0px 0px 1px rgba(0, 0, 0, 0.2)
          // border: 1px solid rgba(0,0,0,0.12)!important;
       }  
    }
}
</style>
<template>
  <div style="margin:5px;">
    <v-card>
      <v-card-title>子单列表</v-card-title>
      <slot name="button" />
      <div 
        class="expansion-contain"
        style="padding:10px"
      >
        <v-expansion-panels
          v-model="panel"
          multiple
        >
          <v-expansion-panel
            v-for="(item,i) in childInfoArr"
            :key="i"
            :disabled="item&&item.disabled"
          >
            <v-expansion-panel-header v-if="loadingHash[i]">
              <v-progress-linear
                color="primary"
                indeterminate
                reverse
              />
            </v-expansion-panel-header>
            <v-expansion-panel-header 
              v-if="item"
            >
              {{ item.uid }}【{{ item.is_headcount?'HC申请单':'非HC申请单' }}】{{ item.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="item">
              <div v-if="parentDetail.editable">
                <v-btn
                  depressed
                  dark
                  color="primary"
                  style="margin-right:10px"
                  @click="editItem(item)"
                >
                  编辑
                </v-btn> 
                <v-btn
                  depressed
                  dark
                  color="#ff9900"
                  style="margin-right:10px"
                  @click="deleteItem(item)"
                >
                  删除
                </v-btn> 
              </div>
              <ChildHrItem
                v-if="item.is_headcount"
                :detail="item"
              />
              <ChildUnHrItem
                v-else
                :detail="item"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>  
  </div>
</template>
<script>
  import ChildHrItem from './ChildHrItem'
  import ChildUnHrItem from './ChildUnHrItem'
  export default {
    components: {
      ChildHrItem,
      ChildUnHrItem
    },
    props: {
      childInfoArr: {
        type: Array
      },
      loadingHash: {
        type: Object
      },
      parentDetail: {
        type: Object
      }
    },
    data() {
      return {
        panel: [],
      }
    },
    computed: {
      childInfoArrClone() {
        return this.childInfoArr.filter(item => item)
      }
    },
    methods: {
      editItem(item) {
        this.$emit('edit', item)
      },
      deleteItem(item) {
        this.$emit('delete', item)
      }
    }
  }
</script>
